import actionTypes from '../actionTypes';

export function requestMission() {
  return {
    type: actionTypes.MISSION_REQUEST,
  };
}

export function successMission(mission: any) {
  return {
    type: actionTypes.MISSION_SUCCESS,
    value: mission,
  };
}

export function failMission(e: any) {
  return {
    type: actionTypes.MISSION_FAIL,
    exception: e,
  };
}

export function updateMission(field: string, value: any, missionId: any) {
  return {
    type: actionTypes.MISSION_UPDATE,
    value: { field, value, missionId },
  };
}

export function updateMissionTotalWinAndFreeSpinCount(value: any, missionId: any) {
  return {
    type: actionTypes.UPDATE_MISSION_TOTAL_WIN_AND_FREE_SPIN_COUNT,
    value: { value, missionId },
  };
}
